import { useSearchParams } from "react-router-dom";
import CategoryBrowser from "@/pages/category/components/CategoryBrowser";
import { usePageMeta } from "@/hooks/usePageMeta";
import { movieList } from "@/mocks/movies";
import type { MediaItem } from "@/types";

const movies = movieList as MediaItem[];

export default function MovieCategory() {
  const [searchParams] = useSearchParams();
  const genre = searchParams.get("genre") || "全部";

  usePageMeta({
    title: "四虎视频-电影分类-丰富电影资源",
    description:
      "四虎视频电影分类页面汇集动作、喜剧、剧情、科幻、悬疑等丰富电影资源，支持按类型、地区、年份筛选，帮助用户快速找到想看的电影。",
    keywords: "电影分类,电影资源,动作片,喜剧片,剧情片,科幻电影,四虎视频电影",
  });

  return (
    <CategoryBrowser
      items={movies}
      title="电影分类"
      description="汇集国内外各类优质电影，支持类型、地区、年份多条件组合筛选，按热度、上映时间或评分排序，轻松找到你想看的那一部。"
      initialGenre={genre}
      crumbs={[{ label: "首页", path: "/" }, { label: "电影" }]}
    />
  );
}